import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ExtracaoDados from '../../pages/operational/extracaoDados/ExtracaoDados';

export default () => (
  <Switch>
    <Route exact path="/intranet/bi/extracao-dados" component={ExtracaoDados} />
  </Switch>
);
